
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/room-layout-planner-app",
      function () {
        return require("private-next-pages/room-layout-planner-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/room-layout-planner-app"])
      });
    }
  